import axiosTokenService from "./axiosTokenService";
import { final_url } from "./Configuration";
import axiosWithOutToken from "../Components/axiosWithOutToken";
import axios from "axios";
class MasterService {



  getIndicators() {
    return axiosTokenService.get(final_url + "indicators")
  }

  getYears() {
    return axiosTokenService.get(final_url + "getYears")
  }

  getDistricts() {
    return axiosTokenService.get(final_url + "getDistricts")
  }

  getMandals(params) {
    return axiosTokenService.post(final_url + "getMandals", params)
  }


  getSubIndicators(params) {
    return axiosTokenService.post(final_url + "subIndicators", params)
  }

  getIndicatorsList(params) {
    return axiosTokenService.post(final_url + "indicatorsList", params)
  }
  getPendingList(params) {
    return axiosTokenService.post(final_url + "pendingList", params)
  }

  getSubIndicatorsForTarget(params) {
    return axiosTokenService.post(final_url + "dataEntryForTargets", params)
  }

  getUnits() {
    return axiosTokenService.get(final_url + "getUnits")
  }

  getSourceoffunding() {
    return axiosTokenService.get(final_url + "getSourceOfFunding")
  }

  getLoginDetails(params) {
    return axiosWithOutToken.post(final_url + "api/userData", params)
  }

  getDeptartments(params) {
    return axiosTokenService.post(final_url + "getDeptartments", params)
  }
  getApplicableDistrictHods(params) {
    return axiosTokenService.post(final_url + "getApplicableDistrictHods", params)
  }
  getApplicableMandalHods(params) {
    return axiosTokenService.post(final_url + "getApplicableMandalHods", params)
  }

  getApplicableHodsTargets(params) {
    return axiosTokenService.post(final_url + "getApplicableHodsTargets", params)
  }




  getAllTables() {
    return axiosTokenService.get(final_url + "allTables")
  }

  AllDeptartments() {
    return axiosWithOutToken.get(final_url + "api/departments");
  }

  getEmployeeDetails(params) {
    return axiosTokenService.post(final_url + "getEmployeeDetails", params);
  }

   getfinyears() {
    return axiosWithOutToken.get(final_url + "api/finyears");
  }
   getAllDepts(params) {
    return axiosTokenService.post(final_url + "getAllDepts", params)
  }
   loginkpicount() {
    return axiosWithOutToken.get(final_url+ "api/secwisekpiscountfordashboard"); 
  }
  getindicatorsTypes() {
  return axiosWithOutToken.get(final_url + "api/indicatorsTypes")
}
   getactivities(params) {
    return axiosTokenService.post(final_url + "activityList", params)
  }
   saveactivities(formData) {
    return axiosTokenService.post(final_url + "saveNewsEventsCircularsGos", formData)
  }
getlistofactivities() {
  return axiosWithOutToken.get(final_url + "api/getNewsEventsCircularsGos")
}

getGoPdf  (fileName) {
  return axiosWithOutToken.get(final_url+`viewFile?fileName=${fileName}`, {
    responseType: 'blob'
  });
};
getkpiMonths(params) {
    return axiosTokenService.post(final_url + "kpiMonths", params)
  }
  getfinTargetyears() {
    return axiosWithOutToken.get(final_url + "api/finTargetyears");
  }
  getindicatorAcceptanceYear() {
    return axios.get(final_url + "api/indicatorAcceptanceYears")
  }
}
export default new MasterService();
